module.exports = __webpack_public_path__ + "img/nlogo1.6a70d3c3.png";